<template>
  <div class="Footer">
    © 杭州货吉达科技有限公司 &nbsp&nbsp  
    <span class="beian" @click="toPage">浙ICP备2025148314号</span>
         
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {

    };
  },
  mounted(){
      this.initial()
  },
  methods: {
        async initial(){

        },
        toPage(){
          window.open('https://beian.miit.gov.cn/')
        }
  }
};
</script>

<style lang="scss" scoped>
.Footer{
    width: 100%;
    position: fixed;
    min-height: $footerHeight;
    bottom: 0;
    z-index: -1;
    background-color: $blue;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    @media screen and (max-width: 767px) {
      padding: 0 40px;
      box-sizing: border-box;
      text-align: center;
  }
  .beian{
    cursor: pointer;
  }
}
</style>
